<script setup lang="ts">
import { computed, ref } from 'vue';
import EntityPortrait from './EntityPortrait.vue';
import EntityPortraitStrip from './EntityPortraitStrip.vue';
import type { EntitySummary } from '../types/entities';

const props = withDefaults(defineProps<{
  entities: EntitySummary[];
  label: string;
  size?: 'sm' | 'md' | 'lg';
  initiallyOpen?: boolean;
}>(), { size: 'md', initiallyOpen: true });
const emit = defineEmits<{ openEntity: [id: string] }>();
const expanded = ref(props.initiallyOpen);
const uniqueEntities = computed(() => [...new Map(props.entities.map((entity) => [entity.id, entity])).values()]);
function toggle(event: Event) { expanded.value = (event.currentTarget as HTMLDetailsElement).open; }
</script>

<template>
  <details class="entity-portrait-panel writing-details" :open="expanded" @toggle="toggle">
    <summary>
      <span><strong>{{ label }}</strong><small>{{ uniqueEntities.length ? `${uniqueEntities.length} ${uniqueEntities.length === 1 ? 'Figur' : 'Figuren'}` : 'Noch keine Figuren zugeordnet' }}</small></span>
      <span v-if="!expanded && uniqueEntities.length" class="entity-portrait-panel-preview" aria-hidden="true"><EntityPortrait v-for="entity in uniqueEntities.slice(0, 6)" :key="entity.id" :entity="entity" size="xs" /><em v-if="uniqueEntities.length > 6">+{{ uniqueEntities.length - 6 }}</em></span>
      <i aria-hidden="true">⌄</i>
    </summary>
    <div class="writing-details-body entity-portrait-panel-body">
      <EntityPortraitStrip :entities="uniqueEntities" :size="size" :label="label" show-names show-empty @open-entity="emit('openEntity', $event)" />
    </div>
  </details>
</template>

<style scoped>
.entity-portrait-panel{margin-top:18px;margin-bottom:12px}
.entity-portrait-panel-preview{display:flex;align-items:center;margin-left:auto;margin-right:9px}.entity-portrait-panel-preview :deep(.entity-portrait + .entity-portrait){margin-left:-6px}.entity-portrait-panel-preview em{display:grid;place-items:center;width:25px;height:25px;margin-left:-4px;border:1px solid var(--ui-border-strong);border-radius:50%;color:var(--ui-action-text);background:var(--ui-surface-3);font-size:9px;font-style:normal;font-weight:850}
.entity-portrait-panel-body{padding-top:4px}.entity-portrait-panel-body :deep(.entity-portrait-strip){padding:10px 0 4px;border:0}.entity-portrait-panel-body :deep(.entity-portrait-strip-label){display:none}
</style>
